import { BlockCtaType } from '../../models/Content';
import { transformCta } from '../../utils/transformers';
import { BlockCtaData } from './model';

export const transformBlockCta = (contentItem: BlockCtaType): BlockCtaData => {
    return {
        id: contentItem.sys.id,
        title: contentItem.fields.title,
        description: contentItem.fields.description,
        cta: contentItem.fields.cta.map(transformCta),
        displayOption: contentItem.fields.displayOption,
        colorOption: contentItem.fields.colorOption,
    };
};
